import { Component, OnInit, Output, Input } from '@angular/core';
import { SchemaPropertyNode } from "../../../../components/SchemaPropertyNode";

@Component({
  selector: 'app-entity-schema-editor',
  template: `<div class="schemaEditorBox">
  <div class="schemaEditorHeader">
    <h6 class="col-md-3">Schema Editor Box</h6>
    <div class="schemaEditorToolSection">
      <div class="schemaEditorToolSectionItem">
        <i class="fa fa-upload schema-icon" title="Import Json schema of Json Object" (click)="uploadJson.click()"></i>      

        <input type="file" class="hidden" (change)="FileChangeEvent($event)" #uploadJson>
      </div>
    </div>
  </div>

  <div class="root">
    <app-entity-schema-node  (deleteEvent)="onDeleteNodeEvent($event)" [propertyNode]="root"></app-entity-schema-node>
  </div>
</div>`,
  styles: [`div.root{margin-top:5px;padding:5px;overflow-y:auto;height:400px}.schemaEditorToolSection{border-bottom:1px solid #e9ecef;width:100%;padding-top:5px;padding-right:18px}.schemaEditorToolSectionItem{float:right;margin-right:15px}.schemaEditorHeader{border-bottom:1px solid #e9ecef;display:-webkit-box;display:-ms-flexbox;display:flex}.schemaEditorHeader h6{padding:5px}.schemaEditorBox{border:1px solid #87ceeb;border-radius:9px;padding:9px;margin-top:13px}::-webkit-scrollbar{width:10px}::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px grey;box-shadow:inset 0 0 5px grey;border-radius:10px}::-webkit-scrollbar-thumb{background:#87ceeb;border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#87ceeb}.schema-icon{font-size:25px}`]
})
export class EntitySchemaEditorComponent implements OnInit {

  @Input() root: SchemaPropertyNode;
  constructor() { }

  ngOnInit() {

    this.root.propName = "root";
    this.root.propType = "object";
    this.root.propAttributes.push({ key: "description", value: "decribe root" })

  }
  FileChangeEvent(fileInput: any) {
    let CurrentFile = fileInput.target.files[0];

    let reader = new FileReader();

    reader.onload = () => {
      let jsonObj = JSON.parse(reader.result);
      this.root.importSchemaNodeFromJsonObject(jsonObj);

    };
    reader.readAsText(CurrentFile);

  }
  onDeleteNodeEvent(property: SchemaPropertyNode) {
    var index = this.root.properties.findIndex(item => item.key === property.propName);
    if (index > -1) {
      this.root.properties.splice(index, 1);
    }
  }
  downloJsonObject() {    
    var data = "data:text/json;charset=UTF-8," + encodeURIComponent(JSON.stringify(this.root.generateJsonObjectFromSchema()));
    var downloader = document.createElement('a');

    downloader.setAttribute('href', data);
    downloader.setAttribute('download', 'file.json');
    downloader.click();
  } 
}
